import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
const formFields = [{ name: "name", label: "Nombre" }];
const tableCols = ["Nombre"];
function TipoGestiones(props) {
  const { history } = props;
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);
  const [formularioUpdate, setformularioUpdate] = useState({
    name: "",
  });
  const [formularioState, setFormularioState] = useState({
    name: "",
  });
  const [dataState, setDataState] = useState([]);
  const [editable, setEditable] = useState({
    id: "",
  });
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      const res = await fetch(
        Parametros.urlApi + "coll_action_types?is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );
      const data = await res.json();
      console.log({ data });
      setDataState(data);
    }
    llamadaApi();
  }, [update, usuario, history]);

  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };

  let crear = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "coll_action_types/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: Parametros.url,
          },
        });
        let responseJson = await response.json();
        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          document.getElementById("formularioBusqueda").reset();
        } else {
          alert(responseJson.detail);
        }
      } else {
        setEditable({});
      }
    } else {
      alert(usuario.crear);
    }
  };
  let updateHandleChange = (event) => {
    setformularioUpdate({
      ...formularioUpdate,
      [event.target.name]: event.target.value,
    });
  };
  let confirmarEdicion = async (item) => {
    const formToSend = {};

    for (const key in formularioUpdate) {
      if (formularioUpdate[key] !== item[key]) {
        formToSend[key] = formularioUpdate[key];
      }
    }
    console.log({ formToSend });

    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi +
            "coll_action_types/" +
            parseInt(item.call_action_type_id),
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formToSend),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("Elemento editado correctamente");
          setUpdate(!update);
          setEditable({});
        } else {
          alert(responseJson.detail);
          setEditable({});
        }
      } else {
        setEditable({});
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (item) => {
    setEditable(item.call_action_type_id);
    setformularioUpdate(item);
  };
  let cancelarEdicion = () => {
    setEditable({});
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Tipo de Gestiones"}></UserTab>
        <FormCrear handleStageForm={handleStageForm} crear={crear} />
        <div className="col-md-12 table-responsive">
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(dataState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={tableCols}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={tableCols}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {dataState
                  .slice(
                    (paginacionState.skip - 1) * paginacionState.limit,
                    (paginacionState.skip - 1) * paginacionState.limit +
                      paginacionState.limit
                  )
                  .map((item) => {
                  return (
                    <tr key={item.call_action_type_id}>
                      {editable === item.call_action_type_id ? (
                        <>
                          <EdititingTable
                            item={item}
                            formularioUpdate={formularioUpdate}
                            formFields={formFields}
                            updateHandleChange={updateHandleChange}
                            confirmarEdicion={confirmarEdicion}
                            cancelarEdicion={cancelarEdicion}
                          />
                        </>
                      ) : (
                        <>
                          <NormalTable
                            item={item}
                            editar={editar}
                            setUpdate={setUpdate}
                          />
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver} </td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(dataState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}
const FormCrear = ({ crear, handleStageForm }) => {
  return (
    <form id="formularioBusqueda" onSubmit={crear}>
      {formFields.map((item, index) => (
        <div className="col-md-4" key={index}>
          <h5>{item.label}</h5>
          <input
            onChange={handleStageForm}
            name={item.name}
            required
            className="form-control"
          ></input>
        </div>
      ))}
      <div className="col-md-4">
        <br />
        <button
          type="submit"
          value="Submit"
          style={{ margin: "14px 0px" }}
          id="btnBuscar"
          className="form-control button brEdit btn-primary"
        >
          Agregar nuevo
        </button>
      </div>
    </form>
  );
};
const NormalTable = ({ item, editar, setUpdate }) => {
  return (
    <>
      <td>{item.call_action_type_id}</td>
      <td>{item.name} </td>
      <td>
        <abbr title="Editar Elemento">
          <span
            style={{ cursor: "pointer" }}
            onClick={() => editar(item)}
            className="glyphicon glyphicon-pencil"
          ></span>
        </abbr>
        <EliminarElemento
          endpoint={`coll_action_types/${item.call_action_type_id}`}
          onSuccess={() => {
            setUpdate((prev) => !prev);
          }}
        />
      </td>
    </>
  );
};
const EdititingTable = ({
  formularioUpdate,
  formFields,
  updateHandleChange,
  confirmarEdicion,
  cancelarEdicion,
  item,
}) => {
  return (
    <>
      <td>{formularioUpdate.call_action_type_id}</td>
      {formFields.map((item, index) => (
        <td key={index}>
          <input
            value={formularioUpdate[item.name]}
            name={item.name}
            onChange={updateHandleChange}
            className="form-control"
          ></input>
        </td>
      ))}
      <td>
        <abbr title="Confirmar Edición">
          <span
            style={{ cursor: "pointer" }}
            onClick={() => confirmarEdicion(item)}
            className="glyphicon glyphicon glyphicon-ok"
          ></span>
        </abbr>
        <abbr title="Cancelar Edición">
          <span
            style={{ cursor: "pointer" }}
            onClick={cancelarEdicion}
            className="glyphicon glyphicon-share-alt"
          ></span>
        </abbr>
      </td>
    </>
  );
};
export default withRouter(TipoGestiones);
